import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { AppState } from '../../../../core/reducers';
import { BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';
import { FieldTemplateMap } from '../models';
import {
  selectFormTemplateMapPage,
  selectFormTemplateMapPageLoading,
  selectFormTemplateMapShowInitWaitingMessage,
} from '../selectors';

export class FormTemplateMapDatasource extends BaseDataSource {
  private _formTemplateMaps: FieldTemplateMap[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();

    this.loading$ = this.store.select(selectFormTemplateMapPageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectFormTemplateMapShowInitWaitingMessage);
    this.store
      .pipe(select(selectFormTemplateMapPage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._formTemplateMaps = res.items;
        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get formTemplateMaps() {
    return this._formTemplateMaps;
  }
}
